export default "__VITE_ASSET__DKD1I9$N__"